import { del, get, patch, post } from '../../utils/api'
import { AxiosResponse } from 'axios'
import { DataCreateBlockType, UpdateBlockDataType } from './types'

export const fetchModuleScreen = (sid: string): Promise<AxiosResponse> =>
  get(`/courses/module-screens/${sid}`, {
    include: ['blocks', 'blocks.gallery', 'blocks.notion'].join(','),
  })

export const updateBlock = (
  block_id: string,
  data: UpdateBlockDataType
): Promise<AxiosResponse> => patch(`/courses/blocks/${block_id}`, data)

export const sortBlocks = (
  lid: string,
  ids: string[]
): Promise<AxiosResponse> => patch(`/courses/lessons/${lid}/blocks`, { ids })

export const sortModuleScreenBlocks = (
  sid: string,
  ids: string[]
): Promise<AxiosResponse> =>
  patch(`/courses/module-screens/${sid}/blocks`, { ids })

export const deleteBlock = (block_id: string): Promise<AxiosResponse> =>
  del(`/courses/blocks/${block_id}`)

export const createBlock = (
  data: DataCreateBlockType
): Promise<AxiosResponse> => post('/courses/blocks', data)

export const attachLessonBlock = (
  lid: string,
  block_id: string,
  position: number
): Promise<AxiosResponse> =>
  post(`/courses/lessons/${lid}/blocks/${block_id}`, { position })

export const attachModuleScreenBlock = (
  sid: string,
  block_id: string,
  position: number
): Promise<AxiosResponse> =>
  post(`/courses/module-screens/${sid}/blocks/${block_id}`, { position })

export const fetchNotion = (
  block_id: string,
  block_notion_id: string
): Promise<AxiosResponse> =>
  post(`/courses/blocks/${block_id}/notion/${block_notion_id}`)
